module.exports = __webpack_public_path__ + "img/mercado_livre_logo.6934f85c.svg";